import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { InboxSharingCreateInput } from '@libs/types/src/inbox/input-type/inbox-sharing.create-input';
import { InboxSharingUpdateInput } from '@libs/types/src/inbox/input-type/inbox-sharing.update-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class InboxToOrganizationGqlService extends GqlServiceV2 {

    createOrganizationSharing(input: InboxSharingCreateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxSharingCreateInput!) {
                inboxToOrganization {
                    create(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    updateOrganizationSharing(input: InboxSharingUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxSharingUpdateInput!) {
                inboxToOrganization {
                    update(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteOrganizationSharing(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                inboxToOrganization {
                    delete(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
